import React from 'react';
import { Col, Typography } from 'antd';
import CipherLogo from 'icons/cipher_logo';
import Header from '../header';
import { COLORS } from 'themes/colors';

const { Title, Text } = Typography;
const PageNotFound = () => {
  return (
    <div style={{ height: '100vh' }}>
      <Header background={COLORS.transparent} showLanguageDropdown={false} />
      <Col
        style={{
          marginTop: '20%',
          padding: '10px 50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        <CipherLogo size="large" />
        <Title level={4} style={{ marginBottom: '20px' }}>
          404: Page not found
        </Title>
        <Text>
          Please click the link in your text message, or scan the QR code to
          access the correct page
        </Text>
      </Col>
    </div>
  );
};

export default PageNotFound;
